import React from 'react';

import FixedFloater from './FixedFloater';
import FooterItem from './FooterItem';


class Footer extends React.Component {

    constructor(props) {
        super();

        this.state = {
            viewport: {
                width: document.documentElement.clientWidth,
                height: document.documentElement.clientHeight
            }
        };

        this.updateDimensions = this.updateDimensions.bind(this);
    }

    componentDidMount() {
        window.addEventListener("resize", this.updateDimensions);
    }

    componentWillUnmount() {
        window.removeEventListener("resize", this.updateDimensions);
    }

    updateDimensions(event) {
        this.setState({
            viewport: {
                width: document.documentElement.clientWidth,
                height: document.documentElement.clientHeight
            }
        });
    }

    render() {

        var footerContainer = {
            width: "100%",
            alignText: "center",
            alignContent: "center",
            justifyContent: "center",
            marginTop: 20,
            paddingBottom: 10,
            paddingTop: 10,
            textAlign: "center",
        }

        var copyrightStyle = {
            textTransform: "uppercase",
            fontSize: 11,
            color: "#e59409",
            width: "100%",
            textAlign: "center",
            marginTop: 20,
        }


        var columnsContainerStyle = {
            width: "95%",
            display: "flex",
            justifyContent: "space-between",
            margin: 0,
            marginBottom: 15,
            padding: 0,
            flexWrap: "wrap",
            marginLeft: "auto",
            marginRight: "auto",
        }

        var columnItemStyle = {
            padding: 0,
            marginBottom: 20,
        }

        var rowsContainerStyle = {
            listStyleType: "none",
            margin: 0,
            padding: 0,
        }

        var rowItemHeadingStyle = {
            fontSize: 13,
            textTransform: "uppercase",
            fontFamily: "'Libre Franklin'",
            fontWeight: 700,
            color: "#c0c0c0",
            textAlign: "left",
            margin: 0,
            marginBottom: 7,
        }

        var rowItemStyle = {
            cursor: "pointer",
            wordBreak: "none",
            fontSize: 13,
            textTransform: "capitalize",
            fontFamily: "'Libre Franklin'",
            color: "#d0d0d0",
            textAlign: "left",
            marginTop: 2,
       }

        var rowItemHoverStyle = {
            cursor: "pointer",
            wordBreak: "none",
            fontSize: 13,
            textTransform: "capitalize",
            textDecoration: "underline",
            fontFamily: "'Libre Franklin'",
            color: "#f0f0f0",
            textAlign: "left",
            marginTop: 2,
        }

        var viewWidth = this.state.viewport.width;
        if(viewWidth < 410) {

            columnItemStyle["width"] = "100%";
        } else if(viewWidth < 500) {
            columnItemStyle["width"] = "50%";
        } else if(viewWidth < 641) {
            columnItemStyle["width"] = "33%";
        }

        return (
            <div style={footerContainer}>
                <hr/>
                    <div style={columnsContainerStyle}>
                        <section style={columnItemStyle}>
                            <ul style={rowsContainerStyle}>
                                <li style={rowItemHeadingStyle}>Services</li>
                                <li style={rowItemStyle}><FooterItem text="Software Development" normstyle={rowItemStyle} hoverstyle={rowItemHoverStyle} pushTo='/services/softwaredevelopment'/></li>
                                <li style={rowItemStyle}><FooterItem text="Project Management" normstyle={rowItemStyle} hoverstyle={rowItemHoverStyle} pushTo='/services/projectmanagement'/></li>
                                <li style={rowItemStyle}><FooterItem text="Project Rescue" normstyle={rowItemStyle} hoverstyle={rowItemHoverStyle} pushTo='/services/projectrescue'/></li>
                                <li style={rowItemStyle}><FooterItem text="Full list..." normstyle={rowItemStyle} hoverstyle={rowItemHoverStyle} pushTo='/services/fulllist'/></li>
                            </ul>
                        </section>
                        <section style={columnItemStyle}>
                            <ul style={rowsContainerStyle}>
                                <li style={rowItemHeadingStyle}>Platforms</li>
                                <li style={rowItemStyle}><FooterItem text="Android" normstyle={rowItemStyle} hoverstyle={rowItemHoverStyle} pushTo='/platforms/android'/></li>
                                <li style={rowItemStyle}><FooterItem text="iOS" normstyle={rowItemStyle} hoverstyle={rowItemHoverStyle} pushTo='/platforms/ios'/></li>
                                <li style={rowItemStyle}><FooterItem text="Mobile Hybrid" normstyle={rowItemStyle} hoverstyle={rowItemHoverStyle} pushTo='/platforms/mobilehybrid'/></li>
                                <li style={rowItemStyle}><FooterItem text="Server / Cloud" normstyle={rowItemStyle} hoverstyle={rowItemHoverStyle} pushTo='/platforms/servercloud'/></li>
                                <li style={rowItemStyle}><FooterItem text="Desktop" normstyle={rowItemStyle} hoverstyle={rowItemHoverStyle} pushTo='/platforms/desktop'/></li>
                                <li style={rowItemStyle}><FooterItem text="Web" normstyle={rowItemStyle} hoverstyle={rowItemHoverStyle} pushTo='/platforms/web'/></li>
                                <li style={rowItemStyle}><FooterItem text="Embedded / IoT" normstyle={rowItemStyle} hoverstyle={rowItemHoverStyle} pushTo='/platforms/embeddediot'/></li>
                            </ul>
                        </section>
                        <section style={columnItemStyle}>
                            <ul style={rowsContainerStyle}>
                                <li style={rowItemHeadingStyle}>Industries</li>
                                <li style={rowItemStyle}><FooterItem text="Consumer" normstyle={rowItemStyle} hoverstyle={rowItemHoverStyle} pushTo='/industries/consumer'/></li>
                                <li style={rowItemStyle}><FooterItem text="Aviation / Aerospace / Marine" normstyle={rowItemStyle} hoverstyle={rowItemHoverStyle} pushTo='/industries/aerospace_marine'/></li>
                                <li style={rowItemStyle}><FooterItem text="Homeland Security / Defense" normstyle={rowItemStyle} hoverstyle={rowItemHoverStyle} pushTo='/industries/defense_homeland_security'/></li>
                                <li style={rowItemStyle}><FooterItem text="Medical & Medical Devices" normstyle={rowItemStyle} hoverstyle={rowItemHoverStyle} pushTo='/industries/medical'/></li>
                                <li style={rowItemStyle}><FooterItem text="Financial / Insurance" normstyle={rowItemStyle} hoverstyle={rowItemHoverStyle} pushTo='/industries/finance_insur'/></li>
                                <li style={rowItemStyle}><FooterItem text="Navigation / Mapping / GPS" normstyle={rowItemStyle} hoverstyle={rowItemHoverStyle} pushTo='/industries/nav_map_gps'/></li>
                                <li style={rowItemStyle}><FooterItem text="IoT - Internet of Things" normstyle={rowItemStyle} hoverstyle={rowItemHoverStyle} pushTo='/industries/iot'/></li>
                                <li style={rowItemStyle}><FooterItem text="Full list..." normstyle={rowItemStyle} hoverstyle={rowItemHoverStyle} pushTo='/industries/full_list'/></li>
                            </ul>
                        </section>
                        <section style={columnItemStyle}>
                            <ul style={rowsContainerStyle}>
                                <li style={rowItemHeadingStyle}>Downloads</li>
                                <li style={rowItemStyle}><FooterItem text="Resume" normstyle={rowItemStyle} hoverstyle={rowItemHoverStyle} pushTo='/resume'/></li>
                                <li style={rowItemStyle}><FooterItem text="Timeline of Projects" normstyle={rowItemStyle} hoverstyle={rowItemHoverStyle} pushTo='/projecthistory'/></li>
                                <li style={rowItemStyle}><FooterItem text="" normstyle={rowItemStyle} hoverstyle={rowItemHoverStyle}/></li>
                            </ul>
                            <ul style={rowsContainerStyle}>
                                <li style={rowItemHeadingStyle}>My Apps</li>
                                <li style={rowItemStyle}><FooterItem text="Android Apps" normstyle={rowItemStyle} hoverstyle={rowItemHoverStyle} pushTo='/myapps/android'/></li>
                                <li style={rowItemStyle}><FooterItem text="iOS Apps" normstyle={rowItemStyle} hoverstyle={rowItemHoverStyle} pushTo='/myapps/ios'/></li>
                                <li style={rowItemStyle}><FooterItem text="Other Apps" normstyle={rowItemStyle} hoverstyle={rowItemHoverStyle} pushTo='/myapps/other'/></li>
                            </ul>
                        </section>
                        <section style={columnItemStyle}>
                            <ul style={rowsContainerStyle}>
                                <li style={rowItemHeadingStyle}>Resources</li>
                                <li style={rowItemStyle}><FooterItem text="Equipment" normstyle={rowItemStyle} hoverstyle={rowItemHoverStyle} pushTo='/resources/equipment'/></li>
                                <li style={rowItemStyle}><FooterItem text="Subscriptions" normstyle={rowItemStyle} hoverstyle={rowItemHoverStyle} pushTo='/resources/subscriptions'/></li>
                                <li style={rowItemStyle}><FooterItem text="" normstyle={rowItemStyle} hoverstyle={rowItemHoverStyle}/></li>
                            </ul>
                            <ul style={rowsContainerStyle}>
                                <li style={rowItemHeadingStyle}>Links</li>
                                <li style={rowItemStyle}><FooterItem text="LinkedIn" normstyle={rowItemStyle} hoverstyle={rowItemHoverStyle} openNew='http://www.linkedin.com/in/roywatson3'/></li>
                                <li style={rowItemStyle}><FooterItem text="GitHub" normstyle={rowItemStyle} hoverstyle={rowItemHoverStyle} openNew='https://github.com/roywatson'/></li>
                            </ul>
                        </section>
                        <section style={columnItemStyle}>
                            <ul style={rowsContainerStyle}>
                                <li style={rowItemHeadingStyle}>Contact</li>
                                <li style={rowItemStyle}><FooterItem text="Contact Me" normstyle={rowItemStyle} hoverstyle={rowItemHoverStyle} pushTo='/contact'/></li>
                                <li style={rowItemStyle}><FooterItem text="Email" normstyle={rowItemStyle} hoverstyle={rowItemHoverStyle} emailTo='rwatson@roywatson.com?subject=Website inquiry'/></li>
                                <li style={rowItemStyle}><FooterItem text="+1 802.735.1500" normstyle={rowItemStyle} hoverstyle={rowItemHoverStyle}/></li>
                                <li style={rowItemStyle}><FooterItem text="" normstyle={rowItemStyle} hoverstyle={rowItemHoverStyle}/></li>
                                <li style={rowItemStyle}><FooterItem text="Privacy Policy" normstyle={rowItemStyle} hoverstyle={rowItemHoverStyle} pushTo='/privacypolicy'/></li>
                                <li style={rowItemStyle}><FooterItem text="Terms and Conditions" normstyle={rowItemStyle} hoverstyle={rowItemHoverStyle} pushTo='/termsandconditions'/></li>
                            </ul>
                        </section>
                    </div>

                <hr/>
                <p style={copyrightStyle}> © 1998-2025 Roy Watson</p>
                <p style={copyrightStyle}>{viewWidth}</p>
                <FixedFloater left="15" text="CV/Resume" background="#dd1111" pushTo='/resume'/>
                <FixedFloater right="15" text="Contact Me" background="#1170dd" pushTo='/contact'/>
            </div>
        );
    }
}

export default Footer


// WEBPACK FOOTER //
// src/static/Footer.js